import React from 'react';
import PropTypes from 'prop-types';
import { Experiment } from '../Experiment';
import cnames from 'classnames';

import { HeroImageSources, HeroImageSourcesWebp } from './HeroImageSource';

import './HeroImage.less';

const CNAME = 'HeroImage';


class HeroImage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    require('object-fit-images')();
  }

  render() {
    const { children, treatments, title } = this.props;
    return (
      <Experiment name={'HA_PTA_HP_NewVRBOHeroImage'} report>
        <Experiment name={'HA_PTA_HP_StayzOnPlatform'}>
          {value => (
            <Experiment name="HA_PTA_HP_WebpImageFormat">
              {WebpImage => (
                <div className={CNAME} >
                  <picture className={`${CNAME}__picture`}>
                    { WebpImage ? <HeroImageSourcesWebp treatments={treatments} title={title} /> : <HeroImageSources treatments={treatments} title={title} /> }
                  </picture>
                  <div className={cnames(`${CNAME}__content`, { [`${CNAME}__content--overlapping-value-props`]: value === 0 })}>
                    {children}
                  </div>
                </div>
              )
              }
            </Experiment>
          )}
        </Experiment>
      </Experiment>
    );
  }
}

HeroImage.propTypes = {
  treatments: PropTypes.arrayOf(PropTypes.shape({
    defaultImg: PropTypes.bool.isRequired,
    href: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired
  })).isRequired,
  title: PropTypes.string
};

export default HeroImage;
